export default {
  NEW: 'NEW',
  CRITICAL: 'CRITICAL',
  NORMAL: 'NORMAL',
  APPROVED: 'APPROVED',
} as const
